import React, { useEffect, useRef, useState } from 'react';
import './ResizableEvidence.css';

export default function ResizableEvidence({ children, label = 'Figure', defaultWidth = 560, defaultHeight = 480 }) {
  const box = useRef(null);
  const [size, setSize] = useState({ width: defaultWidth, height: defaultHeight });
  const [measured, setMeasured] = useState(size);
  useEffect(() => {
    if (!box.current || typeof ResizeObserver === 'undefined') return undefined;
    let frame;
    const observer = new ResizeObserver(() => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const rect = box.current.getBoundingClientRect();
        setMeasured({ width: Math.round(rect.width), height: Math.round(rect.height) });
        // Plotly's existing resize handler listens to this event.
        window.dispatchEvent(new Event('resize'));
      });
    });
    observer.observe(box.current);
    return () => { observer.disconnect(); cancelAnimationFrame(frame); };
  }, []);
  const change = (axis, value) => {
    const n = Number(value), min = axis === 'width' ? 280 : 240;
    if (!Number.isFinite(n) || n < min || n > 3000) return;
    const next = { ...measured, [axis]: n };
    setSize(next); setMeasured(next);
    // Also reset any inline dimensions changed by the browser's drag handle.
    if (box.current) { box.current.style.width = `${next.width}px`; box.current.style.height = `${next.height}px`; }
  };
  const reset = () => { const next = { width: defaultWidth, height: defaultHeight }; setSize(next); setMeasured(next); if (box.current) { box.current.style.width = `${next.width}px`; box.current.style.height = `${next.height}px`; } };
  return <div className="evidence-figure">
    <div className="evidence-size-controls">
      <label>Width <input aria-label={`${label} width`} type="number" min="280" max="3000" step="20" value={measured.width} onChange={event => change('width', event.target.value)} /></label>
      <label>Height <input aria-label={`${label} height`} type="number" min="240" max="3000" step="20" value={measured.height} onChange={event => change('height', event.target.value)} /></label>
      <button type="button" onClick={reset}>Reset figure size</button><span>px · drag the lower-right corner to resize</span>
    </div>
    <div className="evidence-resize-box" ref={box} style={{ width: size.width, height: size.height }}>
      {typeof children === 'function' ? children({ width: Math.max(0, measured.width - 2), height: Math.max(0, measured.height - 2) }) : children}
    </div>
  </div>;
}
